import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApolloClassService } from '@core/graphql/apolloClass.service';
import { ApolloFeeService } from '@core/graphql/apolloFee.service';
import { ApolloGradeService } from '@core/graphql/apolloGrade.service';
import { ApolloSchoolService } from '@core/graphql/apolloSchool.service';
import { ApolloStudentService } from '@core/graphql/apolloStudent.service';
import { ApolloUserService } from '@core/graphql/apolloUser.service';
import { DatePipeService } from '@core/pipe/datepipe.service';
import { SharedService } from '@shared/service/sharedservice';

@Component({
    selector: 'app-kidsprofile-information',
    templateUrl: './kidsprofile-information.component.html',
    styleUrls: ['./kidsprofile-information.component.scss']
})
export class KidsProfileFormComponent implements OnInit {
  editForm!: FormGroup;
  studentId: any;
  studentDetail: any;
  isEditMode = false;
  submitted = false;
  loading: boolean = false;
  showAlert: boolean = false;
  alertProperties = { type: '', message: '' };
  modalState: boolean = false;
  modalTemplate: any = {};
  modalSize: any = {};
  breadcrumb = [
    { level: "My kids", path: "/parent/mykids", current: false },
    { level: "Student Details", path: "", current: true }
  ];
  userParentList: any[] = [];
  userStaffList: any[] = [];
  gradeList: any[] = [];
  classList: any[] = [];
  filteredClassList: any[] = [];
  schoolYearList: any[] = [];
  operatingHourList: any[] = [];
  staffList: any[] = [];
  okuTypeList: any[] = [];
  feeRegistrationList: any[] = [];
  feeMonthlyList: any[] = [];
    isOku: boolean = false;
    isStaffSpecificStudent: boolean = false;
    private isOkuSubscriptionInitialized = false;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private studentService: ApolloStudentService, private schoolService: ApolloSchoolService, 
    private gradeService: ApolloGradeService, private classService: ApolloClassService, private userService: ApolloUserService, private feeService: ApolloFeeService, private datePipeService: DatePipeService,
    private sharedService: SharedService
  ) {
    this.route.paramMap.subscribe(params => {
      this.studentId = params.get('id');
    });
  }

  @ViewChild('saveTemplateHeader', { static: true }) saveTemplateHeader!: TemplateRef<object>;
  @ViewChild('saveTemplateBody', { static: true }) saveTemplateBody!: TemplateRef<object>;
  @ViewChild('saveTemplateFooter', { static: true }) saveTemplateFooter!: TemplateRef<object>;
  @ViewChild('deleteTemplateHeader', { static: true }) deleteTemplateHeader!: TemplateRef<object>;
  @ViewChild('deleteTemplateBody', { static: true }) deleteTemplateBody!: TemplateRef<object>;
  @ViewChild('deleteTemplateFooter', { static: true }) deleteTemplateFooter!: TemplateRef<object>;

  ngOnInit(): void {
    this.initData();
    this.initForm();
  }

  initData() {
    this.studentDetail = null;
    this.userParentList = [];
    this.userStaffList = [];
    this.gradeList = [];
    this.classList = [];
    this.filteredClassList = [];
    this.schoolYearList = [];
    this.operatingHourList = [];
    this.staffList = [];
    this.okuTypeList = [];
    this.feeRegistrationList = [];
    this.feeMonthlyList = [];
    this.isOku = false;
    this.isStaffSpecificStudent = false;
    this.getStudentById(this.studentId);
    this.getUserList();
    this.getGradeList();
    this.getOkuTypeList();
    this.getSchoolYearList();
    this.getOperatingHourList();
    this.getFeeList();
  }

    initForm() {
        this.editForm = this.formBuilder.group({
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            birthCertificateNo: [null, Validators.required],
            myKidNo: [null, Validators.required],
            dateOfBirth: [null, Validators.required],
            gender: [null, Validators.required],
            isOku: [null, Validators.required],
            refOkuTypeId: [null],
      gradeId: [null, Validators.required],
      classId: [null, Validators.required],
      userId: [null, Validators.required],
      isStaffSpecificStudent: [null, Validators.required],
      masterStaffUserRoleId: [null],
            operatingHourId: [null, Validators.required],
            feesRegistrationId: [null, Validators.required],
            feesMonthlyId: [null, Validators.required]
        });

        this.editForm.get('isOku')?.valueChanges.subscribe((value) => this.applyOkuRequirement(value));
        // apply initial state if student data already present
        this.applyOkuRequirement(this.editForm.get('isOku')?.value);
    }

  getStudentById(id: any) {
    this.loading = true;
    this.studentService.getStudentById(id).subscribe({
      next: (result: any) => {
        this.loading = false;
        this.studentDetail = result;
        this.isOku = result.isOku;
        this.isStaffSpecificStudent = result.class?.grade?.isStaffSpecificStudent
        
        this.classService.getClassList().subscribe({
          next: (response: any) => {
            this.classList = response;
            this.filteredClassList = response.filter((i: any) => {
              return i?.grade?.id === result.class?.grade?.id;
            });
          },
          error: (error) => {
            this.displayAlert("danger", "Failed to Fetch Data");
          }
        });
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      },
    });
  }

  onDelete() {
    this.modalSize = {width: '500px', height: '250px'};
    this.modalState = true;
    this.modalTemplate = {header: this.deleteTemplateHeader, body: this.deleteTemplateBody, footer: this.deleteTemplateFooter};
  }

  deleteStudent() {   
    this.modalState = false;
    this.loading = true;

    this.studentService.deleteStudent(this.studentId).subscribe(
      (response) => {
        this.loading = false;
        if (response.success && response.success !== "") {
          this.displayAlert("success", "Student Deleted Successfully");
          setTimeout(() => {
            this.router.navigate(this.sharedService.buildRoleBasedSegments('student', 'listing'));
          }, 1500);
        } else {
          this.displayAlert("danger", response.error);
        }
      },
      (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to delete Student");
      }
    );
  }

  onEdit() {
    this.isEditMode = true;
    var feesRegistrationId: any[] = [];
    var feesMonthlyId: any[] = [];
    this.studentDetail?.masterPayment?.fees?.forEach((x: any) => { 
      if (x?.refFeesType?.name === "Registration") {
        feesRegistrationId.push(x?.id);
      }
      else if (x?.refFeesType?.name === "Monthly") {
        feesMonthlyId.push(x?.id);
      }
    });
    if (this.studentDetail?.class?.grade?.isStaffSpecificStudent) {
      this.editForm.controls['masterStaffUserRoleId'].setValidators([Validators.required]);
    } else {
      this.editForm.controls['masterStaffUserRoleId'].clearValidators();
    }
    this.editForm.patchValue({
      firstName: this.studentDetail?.firstName,
      lastName: this.studentDetail?.lastName,
      birthCertificateNo: this.studentDetail?.birthCertificateNo,
      myKidNo: this.studentDetail?.myKidNo,
      dateOfBirth: this.studentDetail?.dateOfBirth,
      gender: this.studentDetail?.gender,
      isOku: this.studentDetail?.isOku,
      refOkuTypeId: this.studentDetail?.refOkuType?.id,
      gradeId: this.studentDetail?.class?.grade?.id,
      classId: this.studentDetail?.class?.id,
      userId: this.studentDetail?.user?.id,
      isStaffSpecificStudent: this.studentDetail?.class?.grade?.isStaffSpecificStudent,
      masterStaffUserRoleId: this.studentDetail?.masterStaffAssignee[0]?.userRole?.id,
      operatingHourId: this.studentDetail?.studentOperatingHour[0]?.operatingHour?.id,
      feesRegistrationId: feesRegistrationId,
      feesMonthlyId: feesMonthlyId
    });
  }

  private applyOkuRequirement(value: any): void {
    const control = this.editForm?.get('refOkuTypeId');
    if (!control) {
      return;
    }
    const isOkuSelected = !!value;
    this.isOku = isOkuSelected;
    if (isOkuSelected) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
      control.setValue(null, { emitEvent: false });
    }
    control.updateValueAndValidity({ emitEvent: false });
  }

  onCancel() {
    this.isEditMode = false;
  }

  onSave() {
    this.submitted = true;
    if (this.editForm.invalid) { return; }

    this.modalSize = {width: '500px', height: '250px'};
    this.modalState = true;
    this.modalTemplate = {header: this.saveTemplateHeader, body: this.saveTemplateBody, footer: this.saveTemplateFooter};
  }

  updateStudent() {
    this.modalState = false;
    this.loading = true;
    this.submitted = true;
    const formValue = this.editForm.value;

    const userInput = {
      id: Number(this.studentId),
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      birthCertificateNo: formValue.birthCertificateNo,
      myKidNo: formValue.myKidNo,
      dateOfBirth: formValue.dateOfBirth,
      gender: formValue.gender,
      isOku: formValue.isOku,
      refOkuTypeId: formValue.refOkuTypeId,
      classId: formValue.classId,
      userId: formValue.userId,
      isStaffSpecificStudent: formValue.isStaffSpecificStudent,
      masterStaffUserRoleId: formValue.masterStaffUserRoleId,
      operatingHourId: formValue.operatingHourId,
      feesId: [...formValue.feesRegistrationId, ...formValue.feesMonthlyId]
    }

    this.studentService.updateStudent(userInput).subscribe(
      (response) => {
        this.loading = false;
        if (response.success && response.success !== "") {
          this.isEditMode = false;
          this.initData();
          this.initForm();
          this.displayAlert("success", "Student Updated Successfully");
        } else {
          this.displayAlert("danger", response.error);
        }
      },
      (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to update Student");
      }
    );
  }

  onCloseModal() {
    this.modalState = false;
  }

  getUserList() {
    this.loading = true;

    this.userService.getUserList("Parent").subscribe({
      next: (result: any) => {
        this.loading = false;
        var response = result.map((i: any) => {
          return {
            id: i.id,
            fullName: i.firstName + " " + i.lastName
          }
        })
        this.userParentList = response;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
    
    this.userService.getUserList("Staff").subscribe({
      next: (result: any) => {
        this.loading = false;
        var response = result.map((i: any) => {
          return {
            id: i.id,
            fullName: i.firstName + " " + i.lastName,
            userRoleId: i.userRoles?.find((role: any) => role.refRole.name === "Staff")?.id,
          }
        })
        this.userStaffList = response;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  };

  getGradeList() {
    this.loading = true;
    this.gradeService.getGradeList().subscribe({
      next: (result: any) => {
        this.loading = false;
        this.gradeList = result;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  }

  onChangeGrade(value: any) {
    this.checkGradeCapping(value);
    var feesRegistrationId: any[] = [];
    var feesMonthlyId: any[] = [];
    this.feeRegistrationList?.forEach((fee: any) => { fee?.grade.forEach((grade: any) => { if (grade.id === value.id) feesRegistrationId.push(fee?.id)}) });
    this.feeMonthlyList?.forEach((fee: any) => { fee?.grade.forEach((grade: any) => { if (grade.id === value.id) feesMonthlyId.push(fee?.id)}) });
    this.editForm.patchValue({ isStaffSpecificStudent: value.isStaffSpecificStudent, feesRegistrationId: feesRegistrationId, feesMonthlyId: feesMonthlyId, classId: null, masterStaffUserRoleId: null});
    this.isStaffSpecificStudent = value.isStaffSpecificStudent;
    if (this.isStaffSpecificStudent) {
      this.editForm.controls['masterStaffUserRoleId'].setValidators([Validators.required]);
    } else {
      this.editForm.controls['masterStaffUserRoleId'].clearValidators();
    }
    this.filteredClassList = [];
    this.filteredClassList = this.classList.filter((i: any) => {
      return i?.grade?.id === value?.id;
    })
  }

  checkGradeCapping(gradeId: number) {
    this.displayAlert("danger", "This Grade is already full. Please select other Grade");
  }

  getClassList() {
    this.loading = true;
    this.classService.getClassList().subscribe({
      next: (result: any) => {
        this.loading = false;
        this.classList = result;
        this.filteredClassList = result.filter((i: any) => {
          return i?.grade?.id === this.studentDetail?.class?.grade?.id;
        });
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  }

  getSchoolYearList() {
    this.loading = true;
    this.schoolService.getSchoolYearList().subscribe({
      next: (result: any) => {
        this.loading = false;
        this.schoolYearList = result;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  }

  getOperatingHourList() {
    this.loading = true;
    this.schoolService.getOperatingHourList().subscribe({
      next: (result: any) => {
        this.loading = false;
        this.operatingHourList = result;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  }

  getOkuTypeList() {
    this.loading = true;
    this.studentService.getOkuTypeList().subscribe({
      next: (result: any) => {
        this.loading = false;
        this.okuTypeList = result.map((i: any) => {
          return {
            id: i.id,
            name: i.name + " (" + i.description + ")"
          }
        });
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  }

  getFeeList() {
    this.loading = true;
    var registrationFee: any[] = [];
    var monthlyFee: any[] = [];
    this.feeService.getFeeList().subscribe({
      next: (result: any) => {
        (result || []).forEach((fee: any) => {
          const feeType = (fee?.refFeesType?.name ?? '').toLowerCase();
          const feeName = (fee?.name ?? '').trim();
          const hasOTCalculation = !!fee?.otCalculation;
          const isOTMonthly = feeType === 'monthly' && (hasOTCalculation || fee?.otCalculation?.isOverTime === true || /^ot/i.test(feeName));

          if (feeType === 'registration') {
            registrationFee.push(fee);
          } else if (feeType === 'monthly' && !isOTMonthly) {
            monthlyFee.push(fee);
          }
        });
        this.feeRegistrationList = registrationFee;
        this.feeMonthlyList = monthlyFee;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  };

  convertDateTime(dateTime: string, format: string) {
    return this.datePipeService.convertTime(dateTime, format);
  }

  checkDisability(value: boolean) {
    this.isOku = value;
  }

  displayAlert(type: string, message: string) {
    this.showAlert = true;
    this.alertProperties = { type: type, message: message }
    window.setTimeout(() => {
      this.showAlert = false;
    }, 5000)
  }
}
